import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';

const ConversationListTable = () => {
  return (
    <div className="border-bottom">
      <AdvanceTable
        tableProps={{ id: 'conversationsTable', className: 'phoenix-table border-top border-200 fs-9' }}
      />
      <AdvanceTableFooter pagination className="py-3" />
    </div>
  );
};

export default ConversationListTable;
